"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _axios = _interopRequireDefault(require("axios"));

var _helpers = require("utils/helpers");

var SizeGuide = /*#__PURE__*/function () {
  function SizeGuide(component) {
    (0, _classCallCheck2["default"])(this, SizeGuide);
    this.dom = {
      $component: component,
      $open: Array.from(document.querySelectorAll('.js-size-guide-panel-open')),
      $close: Array.from(document.querySelectorAll('.js-size-guide-panel-close'))
    }, this.state = {
      open: false,
      animating: false,
      loading: false,
      requiredReload: false,
      modelView: false,
      sort: 'featured',
      checkboxes: '',
      activeFilters: 0,
      openDuration: 500,
      closeDuration: 750,
      activeClass: 'is-active',
      parser: new DOMParser(),
      isShitBrowser: (0, _helpers.isOldIE)(),
      collection: component.getAttribute('data-collection'),
      newFilterURL: component.getAttribute('data-collection')
    };
    this.toggleHandler = this.toggle.bind(this);
    this.keydownHandler = this.onKeydown.bind(this);
    this.clickHandler = this.close.bind(this);
    this.mount(); //to remove:
    //this.toggle();
  }

  (0, _createClass2["default"])(SizeGuide, [{
    key: "mount",
    value: function mount() {
      var _this = this;

      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('SizeGuide : connect', this);
      document.addEventListener('keydown', this.keydownHandler);
      dom.$close.forEach(function ($element) {
        return $element.addEventListener('click', _this.clickHandler);
      });
      console.log((0, _helpers.isOldIE)());

      if (!state.isShitBrowser) {
        dom.$open.forEach(function ($element) {
          return $element.addEventListener('click', _this.toggleHandler);
        });
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var _this2 = this;

      var self = this;
      var dom = this.dom;
      console.log('SizeGuide : connect', this);
      dom.$open.forEach(function ($element) {
        return $element.removeEventListener('click', _this2.toggleHandler);
      });
      document.removeEventListener('keydown', this.keydownHandler);
      dom.$close.forEach(function ($element) {
        return $element.removeEventListener('click', _this2.clickHandler);
      });
    }
  }, {
    key: "toggle",
    value: function toggle(event) {
      var dom = this.dom,
          state = this.state;
      console.log('SizeGuide : toggle', this);

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (state.open) {
        this.close();
      } else {
        this.open();
      }
    }
  }, {
    key: "open",
    value: function open() {
      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('SizeGuide : open', this);

      if (!state.animating) {
        state.animating = true;
        dom.$component.setAttribute('aria-hidden', false);
        setTimeout(function () {
          dom.$component.classList.add(state.activeClass);
          dom.$open.forEach(function ($element) {
            return $element.classList.add(state.activeClass);
          });
        }, 25);
        setTimeout(function () {
          state.open = true;
          state.animating = false;
          self.notify('open');
        }, state.openDuration);
      }
    }
  }, {
    key: "close",
    value: function close() {
      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('SizeGuide : close', this);

      if (!state.animating) {
        state.animating = true;
        setTimeout(function () {
          dom.$component.classList.remove(state.activeClass);
          dom.$open.forEach(function ($element) {
            return $element.classList.remove(state.activeClass);
          });
        }, 25);
        setTimeout(function () {
          dom.$component.setAttribute('aria-hidden', true);
          state.open = false;
          state.animating = false;
          self.notify('close');
        }, state.closeDuration);
      }
    }
  }, {
    key: "notify",
    value: function notify(action) {
      var dom = this.dom,
          state = this.state;
      console.log('SizeGuide : notify', this);
      var SizeGuideEvent = new CustomEvent("SizeGuide:".concat(action));
      document.dispatchEvent(SizeGuideEvent);
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      var state = this.state;
      console.log('SizeGuide : onKeydown', this, event);
      var escape = event.keyCode === 27;

      if (state.open && escape) {
        this.close();
      }
    }
  }]);
  return SizeGuide;
}();

exports["default"] = SizeGuide;